if (typeof Element.prototype.scrollTo === 'undefined') {
	Element.prototype.scrollTo = function (settings) {
		settings = settings || {};

		this.scrollTop = settings.top || 0;
		this.scrollLeft = settings.left || 0;
	};
}


// WEBPACK FOOTER //
// ./js/polyfills/polyfill-scroll-to.js